/* eslint-disable no-await-in-loop */
import displayError from 'utils/displayError';
import * as dealsApi from 'api/deals.api';
import { $list, $view } from 'signals/global.signals';

export const fetchAndSetDeals = async () => {
  $view.update({ isTableLoading: true });
  try {
    const { data } = await dealsApi.getUserOrgDeals();

    if (data) {
      $list.update({ data, originalData: data });
    }
  } catch (error) {
    displayError({
      message: 'Failed to load deals. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({ isTableLoading: false });
  }
};
